import type {
  WorkspaceMemberInvite,
  WorkspaceInviteRole,
  WorkspaceUserSearchResult,
} from "./workspaceMembers.types";

export const WORKSPACE_INVITE_ROLE_LABELS: Record<WorkspaceInviteRole, string> =
  {
    editor: "Editor",
    viewer: "Viewer",
  };

export const WORKSPACE_INVITE_ROLE_OPTIONS: WorkspaceInviteRole[] = [
  "editor",
  "viewer",
];

export const getInviteKey = (invite: WorkspaceMemberInvite): string =>
  invite.kind === "user"
    ? `user:${invite.userId}`
    : `email:${invite.email.toLowerCase()}`;

export const isEmailAlreadyInvited = (
  invites: WorkspaceMemberInvite[],
  email: string,
): boolean =>
  invites.some(
    (invite) => invite.email.toLowerCase() === email.trim().toLowerCase(),
  );

export const isUserAlreadyInvited = (
  invites: WorkspaceMemberInvite[],
  userId: string,
): boolean =>
  invites.some(
    (invite) => invite.kind === "user" && invite.userId === userId,
  );

export const createUserInvite = (
  user: WorkspaceUserSearchResult,
  role: WorkspaceInviteRole,
): WorkspaceMemberInvite => ({
  kind: "user",
  userId: user.id,
  name: user.name,
  email: user.email,
  title: user.title,
  role,
});

export const createEmailInvite = (
  email: string,
  role: WorkspaceInviteRole,
): WorkspaceMemberInvite => ({
  kind: "email",
  email: email.trim(),
  role,
});
